import { render, staticRenderFns } from "./BaseSlotToolsButtons.vue?vue&type=template&id=911b74b4&scoped=true&"
import script from "./BaseSlotToolsButtons.vue?vue&type=script&lang=js&"
export * from "./BaseSlotToolsButtons.vue?vue&type=script&lang=js&"
import style0 from "./BaseSlotToolsButtons.vue?vue&type=style&index=0&id=911b74b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "911b74b4",
  null
  
)

export default component.exports